import { message } from 'antd';
import axios, { AxiosInstance } from 'axios';
import { apiPath } from 'common/apiPath/apiPath';
import { CustomMessage } from 'common/components';
import store from 'common/redux/store';
import { useEffect, useState } from 'react';

export type actionType = {
  cb?: (resData: any) => void;
  onError?: (error: any) => void;
  method?: string;
  payload?: any;
  urlObjKey: keyof typeof apiPath;
  params?: object;
  isToast?: boolean;
  toastType?: 'small' | 'big';
  successMessage?: string;
  errorMessage?: string;
  paramId?: any;
  // When true, this request uses the original (logged-in) JWT even if an
  // impersonation token is active.
  useOriginalToken?: boolean;
  headers?: Record<string, string>;
  // When true, the request is sent without the global Authorization (Bearer)
  // header — used for endpoints that authenticate via a static API key instead.
  skipAuth?: boolean;
};
export type reqResType = {
  error: any;
  resData: any;
  isLoading: boolean;
  success: any;
};
export type axiosResType = {
  apiAction: actionType;
  error: any;
  resData: any;
  isLoading: boolean;
  success: any;
};


export const useAxiosRequest = (initData: any) => {

  
  const [reqResponse, setReqResponse] = useState({
    error: '',
    resData: initData || '',
    isLoading:  true ,
    success: '',
  });

  useEffect(()=> {
    setReqResponse((prev) => ({
     ...prev,
      isLoading: false,
    }));
  },[])
  const resetData = () => {
    setReqResponse({
      error: '',
      resData: initData || '',
      isLoading: false,
      success: '',
    });
  };
  const apiAction = ({
    method,
    urlObjKey,
    params,
    payload,
    cb,
    onError,
    isToast,
    toastType,
    successMessage,
    errorMessage,
    paramId,
    useOriginalToken,
    headers,
    skipAuth,
  }: actionType) => {
    let url: string = '';
    const pathValue = apiPath[urlObjKey];
    if (typeof pathValue === 'function') {
      url = (pathValue as (id: any) => string)(paramId);
    } else if (paramId) {
      url = `${pathValue}/${paramId}`;
    } else {
      url = String(pathValue);
    }
    setReqResponse({
      error: '',
      resData: initData || '',
      isLoading: true,
      success: '',
    });
    const requestHeaders: Record<string, string> = { ...(headers || {}) };
    if (useOriginalToken) {
      const authState = store.getState().auth;
      const stashedOriginal = authState?.originalToken;
      const activeToken = authState?.profileData?.token;
      const tokenToUse = stashedOriginal || activeToken;
      if (tokenToUse) {
        requestHeaders.Authorization = `Bearer ${tokenToUse}`;
      }
    }
    let client: AxiosInstance = axios;
    if (skipAuth) {
      client = axios.create();
      const commonDefaults = client.defaults.headers.common as Record<string, unknown>;
      delete commonDefaults.Authorization;
      delete commonDefaults.Others;
    }
    client({
      method: method ? method : 'get',
      url: url,
      data: payload && payload,
      params: params,
      headers: requestHeaders,
    })
      .then((res) => {
        setReqResponse((prv) => ({
          ...prv,
          error: '',
          resData: res?.data || initData,
          isLoading: false,
          success: res?.data?.message,
        }));
        cb && cb(res.data);
        if (toastType !== 'small' && isToast) {
          CustomMessage({
            type: 'success',
            content:
              successMessage || res?.data?.message || 'Submitted Successfully',
          });
        }
        if (toastType === 'small') {
          message.success(
            successMessage || res?.data?.message || 'Submitted Successfully'
          );
        }
      })
      .catch((error) => {
        setReqResponse((prv) => ({
          ...prv,
          error: error,
          resData: initData || '',
          isLoading: false,
          success: '',
        }));
        onError && onError(error);
        if (toastType !== 'small' && isToast) {
          CustomMessage({
            type: 'error',
            content:
              errorMessage ||
              error?.response?.data?.message ||
              error?.response?.data?.Message ||
              'Failed, try again',
          });
        }
        if (toastType === 'small') {
          message.error(
            errorMessage ||
              error?.response?.data?.message ||
              error?.response?.data?.Message ||
              'Failed, try again'
          );
        }
      });
  };



  const { error, resData, isLoading, success }: reqResType = reqResponse;
  return { apiAction, resData, isLoading, error, success, resetData };
};

// ========example =============
// POST Request
// loginApiCall.apiAction({
//   urlObjKey: 'login',
//   method: 'POST',
//   payload: {
//     password: '1234',
//     username: 'demo@ibos.io',
//   },
//   isToast: true,
//   modifiedRespons: (data: any) => {
//     data.email = 'jahed';
//   },
// });

// GET Request
/**
 *
 * getBankDDL.apiAction({
 *   urlObjKey:'/rmg/bankddl',
 *   params:{
 *    accountId:accId,
 *    businessUnitId,
 *    }
 * })
 *
 */
